import chroma from "chroma-js";
import React, { useContext, createRef, useState, MutableRefObject, RefObject, useEffect, useRef } from 'react';
import iro from '@jaames/iro';
import { Context } from "../../../../Context/context";

interface IroColorPicker {
  on: (action: string, callback: Function) => void;
  color: {
    hexString: string;
    rgbString: string
    set: (value: any) => void;
    setState: (state: any) => void;
  }
}

interface IroColor {
  rgbString: string,
  hexString: string,
  value: number
}

export interface BlightnessSelecterProps {
  className?: string;
  value?: string;
  onChange?: (value: number) => void;
}

const BlightnessSelecter = ({className, onChange = () => {}}: BlightnessSelecterProps) => {

  const {
    state: { brushColor, colorIsAnimated, globalColorData: {
      darkness}},
  } = useContext(Context);

  const getInitialColor = ( originalColor: string, darkness: number, isAnimated: boolean ): string =>{
    if( !isAnimated ) {
      return chroma(originalColor)
              .darken(darkness)
              .hex();
    } 
    return chroma("#FFFFFF")
      .darken(darkness)
      .hex();
  }

  const [ animated, setAnimated ] = useState( colorIsAnimated )
  const [ currentColor, setColor ] = useState( getInitialColor( brushColor[0], darkness, animated )  )
  let colorPicker: MutableRefObject<IroColorPicker | null> = useRef<IroColorPicker | null>(null);
  let el: RefObject<HTMLDivElement> = createRef<HTMLDivElement>();

  /* eslint react-hooks/exhaustive-deps: off */
  useEffect(() => {
    if (!el.current) {
      return;
    }
    if (!colorPicker.current) {

      // create a new iro color picker and pass component props to it
      // @ts-ignore

      colorPicker.current = new iro.ColorPicker(el.current, {
                                  width: 250,
                                  color: getInitialColor( currentColor, darkness, animated ),
                                  borderWidth: 1,
                                  borderColor: "#fff",
                                  layout: [
                                    {
                                      component: iro.ui.Slider,
                                      options: {
                                        sliderType: 'value'
                                      }
                                    },
                                  ]
                                });
 
      // call onColorChange prop whenever the color changes
      if (!colorPicker?.current) {
        return;
      }

      colorPicker.current.on('color:change', (color: IroColor ) => {
        onChange?.call( this, parseInt((( 1 - color.value / 100 ) * 5 ).toFixed(2)));
      });

    } else {
      if( animated !== colorIsAnimated ) {
        let value = getInitialColor( brushColor[0], darkness, colorIsAnimated );
        colorPicker.current.color.set(value);
        setColor( value )
        setAnimated( colorIsAnimated )        
      } else if  ( !colorIsAnimated ) {
        if(  currentColor !== brushColor[0] ) {
          let nextColor = getInitialColor( brushColor[0], darkness, false )
          colorPicker.current.color.set( nextColor )
          setColor( nextColor )
        }
      }
    }
  }, [colorIsAnimated, brushColor]);
  return  <>
            <div className={className} ref={el} id="blightnessPicker" />
          </>;
};

export default BlightnessSelecter;
